import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, concatMap, take } from 'rxjs';

import { VendorTrade } from '../classes/models/vendor-trade';
import { AuthService } from './auth.service';
import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root'
})
export class VendorTradeService {
  constructor(
    private http: HttpClient,
    private AuthService: AuthService,
    private ToastService: ToastService
  ) {}

  getVendorTrades(query = {}) {
    return this.AuthService.getUserType().pipe(
      take(1),
      concatMap((userType: string) => {
        const userTypeToObservableMap: {
          [key: string]: () => Observable<any>;
        } = {
          Admin: () =>
            this.http.get(`/api/v2/admin/vendorTrade/many`, { params: query })
        };

        if (userTypeToObservableMap[userType]) {
          return userTypeToObservableMap[userType]();
        }

        throw this.ToastService.addErrorToast('Error', 'Invalid permission.', {
          returnError: true
        });
      })
    );
  }

  getVendorTradesCount(query = {}) {
    return this.AuthService.getUserType().pipe(
      take(1),
      concatMap((userType: string) => {
        const userTypeToObservableMap: {
          [key: string]: () => Observable<any>;
        } = {
          Admin: () =>
            this.http.get(`/api/v2/admin/vendorTrade/count`, { params: query })
        };

        if (userTypeToObservableMap[userType]) {
          return userTypeToObservableMap[userType]();
        }

        throw this.ToastService.addErrorToast('Error', 'Invalid permission.', {
          returnError: true
        });
      })
    );
  }

  // Need to test this.
  saveVendorTrades(
    VendorId: number,
    VendorTrades: VendorTrade[],
    query = {}
  ): Observable<any> {
    return this.http.post(
      `/api/v2/vendor/${VendorId}/vendorTrade`,
      VendorTrades,
      { params: query }
    );
  }

  deleteVendorTrade(VendorTradeId: number, query = {}) {
    return this.AuthService.getUserType().pipe(
      take(1),
      concatMap((userType: string) => {
        const userTypeToObservableMap: {
          [key: string]: () => Observable<number>;
        } = {
          Admin: () =>
            this.http.delete<number>(
              `/api/v2/admin/vendorTrade/${VendorTradeId}`,
              { params: query }
            )
        };

        if (userTypeToObservableMap[userType]) {
          return userTypeToObservableMap[userType]();
        }

        throw this.ToastService.addErrorToast('Error', 'Invalid permission.', {
          returnError: true
        });
      })
    );
  }
}
